/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module toBoolean
 */

import _Boolean from './.internal/_Boolean';

export default function toBoolean(value) {
  return _Boolean(value);
}
